import * as React from 'react';
import { ErrorInfo } from 'react';
import { logReactError } from './Services/Logging.Service';
import ErrorTemplate from './Error/ErrorTemplate';

interface IState {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    this.setState({ hasError: true });
    logReactError(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorTemplate
          header="Oops! Something went wrong."
          message="We've been notified and will fix it ASAP."
        />
      );
    }
    return this.props.children;
  }
}
